module.exports = __webpack_public_path__ + "img/team-icon.b7461cad.svg";